


// Define permissions
export const PERMISSIONS = {
    VIEW: 'view',
    APEND: 'apend reciept',
    ADD: 'add',
    EDIT: 'edit',
    DELETE: 'delete',
    ALL: 'all',
    BRANCHES: 'Branches',
    EXPORT: 'Export',
    SETTINGS: 'Settings',
};

// Define role permissions
// SA super Admin
// BAD Branch Admin
export const ROLE_PERMISSIONS = {
    SA: [PERMISSIONS.BRANCHES,PERMISSIONS.SETTINGS,PERMISSIONS.EXPORT],
    AD: [PERMISSIONS.VIEW, PERMISSIONS.ADD, PERMISSIONS.EDIT, PERMISSIONS.DELETE,PERMISSIONS.EXPORT],
    BAD: [PERMISSIONS.VIEW, PERMISSIONS.ADD, PERMISSIONS.EDIT,PERMISSIONS.EXPORT],
    ST: [PERMISSIONS.VIEW, PERMISSIONS.ADD,PERMISSIONS.APEND],
    guest: [PERMISSIONS.VIEW]
};

// Helper function
// const hasPermission = (permission) => {
// return ROLE_PERMISSIONS[userRole]?.includes(permission) || false;
// };

// Usage in JSX:
// {hasPermission(PERMISSIONS.EDIT) && (
// Edit button
// )}

export const getUserRole = () => {
            try {
            const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            return userInfo?.role || '';
            } catch (error) {
            console.error('Error getting user role:', error);
            return '';
            }
        };